import echarts from './echarts.vue';

export default {
  install(application) {
    application.component('yx-echarts', echarts);
  },
};
